const messages = {
    menuTitle: 'Zlecenia spedycyjne',
    pageTitle: 'Zlecenia spedycyjne',

    actions: {
        importFromPrintManager: 'Importuj z Print Managera',
        createFromCampaign: 'Utwórz z kampanii',
        generateReport: 'Generuj raport',
        print: 'Drukuj',
        history: 'Metryka dokumentu',
        open: 'Otwórz'
    },

    filters: {
        invalidForXlOnly: 'ZS, których nie można przesłać do XL',
        status: 'Status',
        noStatus: 'Nie znaleziono statusu',
        search: 'Szukaj...',
        customer: 'Klient',
        createdBy: 'Tworzący',
        noUsers: 'Nie znaleziono',
        orderCreatedFrom: 'Zamówienie od',
        orderCreatedTo: 'Zamówienie do',
        shippingDateFrom: 'Wysyłka od',
        shippingDateTo: 'Wysyłka do'
    },

    usersSearch: {
        emptyPrompt: 'Wpisz treść aby odnaleźć użytkownika.',
        searching: 'Trwa wyszukiwanie...',
        noResults: 'Nie znaleziono'
    },

    table: {
        headers: {
            number: 'Numer',
            customer: 'Klient',
            status: 'Status',
            createdBy: 'Utworzone przez',
            createdAt: 'Data utworzenia',
            expeditionDateTime: 'Planowana data wysyłki',
            deliveryDateTime: 'Data dostawy',
            actions: 'Akcje'
        }
    },

    dialogs: {
        add: {
            title: 'Importowanie zlecenia spedycyjnego',
            fields: {
                number: 'Numer'
            },
            actions: {
                submit: 'Importuj'
            },
            validation: {
                numberRequired: 'Numer zlecenia jest wymagany.'
            }
        },
        createFromCampaign: {
            title: 'Utworzenie z kampanii',
            fields: {
                deliveryMethod: 'Środek transportu',
                search: 'Szukaj...'
            },
            headers: {
                order: 'Zamówienie',
                name: 'Nazwa',
                productType: 'Typ produktu',
                plannedSendDate: 'Data wysyłki',
                amount: 'Ilość',
                actions: 'Akcje'
            },
            actions: {
                addToBuffer: 'Dodaj do Bufora',
                removeFromBuffer: 'Usuń z bufora'
            },
            tooltips: {
                addToBuffer: 'Dodaj do schowka',
                removeFromBuffer: 'Usuń ze schowka'
            },
            noData: 'Nie znaleziono zamówień',
            noDeliveryMethods: 'Nie znaleziono środka transportu',
            bufferAdded: 'Dodano: {count}'
        },
        buffer: {
            title: 'Utworzenie z kampanii: Wybrane produkty',
            headers: {
                campaign: 'Kampania',
                order: 'Zamówienie',
                name: 'Nazwa',
                productType: 'Typ produktu',
                plannedSendDate: 'Data wysyłki',
                amount: 'Ilość',
                actions: 'Akcje'
            },
            actions: {
                remove: 'Usuń'
            },
            noData: 'Nie dodano żadnych produktów'
        }
    },

    history: {
        title: 'Metryka dokumentu',
        headers: {
            changedBy: 'Zmieniający',
            changedAt: 'Data utworzenia',
            actions: 'Akcje'
        },
        pagination: {
            itemsPerPageText: 'Zmian na stronie'
        },
        actions: {
            open: 'Otwórz'
        },
        details: {
            title: 'Szczegóły metryki dokumentu (ZS {number})',
            changeFallback: 'Zmiana',
            headers: {
                changeType: 'Typ zmiany',
                name: 'Nazwa',
                oldValue: 'Wartość przed',
                newValue: 'Wartość po'
            },
            values: {
                selected: 'Wybrana',
                notSelected: 'Nie wybrana'
            }
        }
    },

    details: {
        pageTitle: 'Zlecenie spedycyjne',
        backButton: 'Powrót do listy',
        backToJobButton: 'Powrót do zlecenia',
        tabs: {
            goods: 'Towary',
            addresses: 'Adresy'
        },
        sections: {
            parameters: 'Parametry zlecenia',
            customer: 'Dane klienta',
            notes: 'Uwagi',
            costs: 'Zamówienia - koszty',
            addresses: 'Adresy',
            packages: 'Pakowanie',
            wares: 'Towary',
            attachments: 'Rozdzielniki'
        },
        fields: {
            createdAt: 'Data utworzenia',
            trader: 'Handlowiec',
            plannedCost: 'Kwota założona za transport',
            orderNetPrice: 'Cena netto zamówień',
            productionCost: 'Koszt materiałów',
            customerName: 'Nazwa klienta',
            companyName: 'Nazwa firmy',
            taxNumber: 'NIP',
            address: 'Adres',
            street: 'Ulica',
            postCode: 'Kod pocztowy',
            city: 'Miasto',
            country: 'Kraj',
            phoneNumber: 'Telefon',
            contactPerson: 'Osoba kontaktowa',
            distance: 'Dystans',
            shippingCost: 'Koszt',
            expeditionDateTime: 'Planowana data wysyłki',
            deliveryDateTime: 'Data dostawy',
            deliveryMethod: 'Środek transportu',
            packageMethod: 'Sposób pakowania',
            packageType: 'Rodzaj opakowania',
            amount: 'Ilość',
            grossWeight: 'Waga brutto',
            dimensions: 'Wymiary',
            forAddress: 'Dla adresu',
            forPackage: 'Dla pakowania',
            orderNetPriceShort: 'Cena netto',
            productionCostShort: 'Koszt materiałów'
        },
        table: {
            goodsHeaders: {
                campaignNumber: 'Kampania',
                productionNumber: 'Zamówienie',
                name: 'Produkt',
                amount: 'Do wysyłki'
            },
            packageWaresHeaders: {
                wareName: 'Towar',
                wareAmount: 'Nakład',
                wareUnitPackageQuantity: 'Ilość kartonów',
                weight: 'Netto / Brutto'
            }
        },
        actions: {
            addAddress: 'Dodaj adres',
            importAddresses: 'Importuj adresy',
            copyAddress: 'Kopiuj adres',
            editAddress: 'Edycja adresu',
            deleteAddress: 'Usuń adres',
            addPackage: 'Dodaj pakowanie',
            editPackage: 'Edycja pakowania',
            deletePackage: 'Usuń pakowanie',
            addWare: 'Dodaj towar',
            editWare: 'Edycja towaru',
            deleteWare: 'Usuń towar',
            save: 'Zapisz',
            sendToXl: 'Wyślij do XL'
        },
        dialogs: {
            position: {
                titleCreate: 'Dodaj adres',
                titleEdit: 'Edycja adresu',
                fields: {
                    availableAddresses: 'Wybierz z dostępnych adresów'
                },
                actions: {
                    calculateCost: 'Oblicz koszt wysyłki'
                },
                noData: 'Brak adresów',
                noCountries: 'Nie znaleziono kraju',
                noDeliveryMethods: 'Nie znaleziono środka transportu',
                validation: {
                    companyNameRequired: 'Proszę podać nazwę firmy.',
                    contactPersonRequired: 'Proszę podać osobę kontaktową.',
                    streetRequired: 'Proszę podać ulicę.',
                    postCodeRequired: 'Proszę podać kod pocztowy.',
                    cityRequired: 'Proszę podać miasto.',
                    countryRequired: 'Proszę podać kraj.',
                    phoneNumberRequired: 'Proszę podać numer telefonu.',
                    deliveryMethodRequired: 'Proszę wybrać środek transportu.',
                    distanceRequired: 'Proszę podać dystans.',
                    costRequired: 'Proszę podać koszt dostawy.',
                    costInvalid: 'Maksymalnie 2 cyfry po przecinku.',
                    expeditionDateTimeRequired: 'Proszę podać planowaną datę wysyłki.',
                    deliveryDateTimeRequired: 'Proszę podać datę dostawy.'
                }
            },
            importAddress: {
                title: 'Import adresów',
                fields: {
                    file: 'Plik Excel',
                    filePlaceholder: 'Wybierz plik'
                },
                actions: {
                    upload: 'Wyślij'
                },
                validation: {
                    contactPersonRequired: 'Proszę podać osobę kontaktową.',
                    phoneNumberRequired: 'Proszę podać numer telefonu.',
                    fileRequired: 'Proszę wybrać plik.',
                    invalidFile: 'Niepoprawny format danych w pliku.'
                }
            },
            package: {
                titleCreate: 'Dodaj pakowanie',
                titleEdit: 'Edycja pakowania',
                fields: {
                    boxType: 'Sposób pakowania',
                    packageType: 'Opakowanie',
                    length: 'Długość',
                    width: 'Szerokość',
                    height: 'Wysokość',
                    packageWeight: 'Waga palety/opakowania',
                    maxWeightCapacity: 'Nośność opakowania',
                    setManuallyAmount: 'Ręczna edycja ilości opakowań',
                    amount: 'Ilość opakowań'
                },
                units: {
                    mm: 'mm',
                    kg: 'kg',
                    pieces: 'szt.'
                },
                validation: {
                    boxTypeRequired: 'Proszę podać sposób pakowania.',
                    packageTypeRequired: 'Proszę podać rodzaj opakowania.',
                    lengthRequired: 'Proszę podać długość.',
                    widthRequired: 'Proszę podać szerokość.',
                    heightRequired: 'Proszę podać wysokość.',
                    maxWeightCapacityRequired: 'Proszę podać nośność opakowania.',
                    amountRequired: 'Liczba opakowań jest wymagana.',
                    amountPositiveInteger: 'Proszę podać całkowitą dodatnią liczbę opakowań.'
                }
            },
            ware: {
                titleCreate: 'Dodaj towar',
                titleEdit: 'Edycja towaru',
                fields: {
                    product: 'Produkt',
                    packageType: 'Opakowanie',
                    amount: 'Nakład',
                    length: 'Długość',
                    width: 'Szerokość',
                    height: 'Wysokość',
                    packageWeight: 'Waga opakowania',
                    maxWeightCapacity: 'Nośność opakowania',
                    setManuallyAmount: 'Ręczna edycja ilości opakowań',
                    wareUnitPackageQuantity: 'Ilość opakowań'
                },
                hints: {
                    productFullyAssigned: 'Produkt w pełni rozpisany.'
                },
                validation: {
                    productRequired: 'Proszę wybrać produkt.',
                    productAlreadyInPackage: 'Wybrany produkt istnieje już w danym pakowaniu.',
                    amountRequired: 'Proszę podać ilość.',
                    amountRange: 'Proszę podać wartość z zakresu 1-{max}.',
                    packageTypeRequired: 'Proszę podać rodzaj opakowania.',
                    lengthRequired: 'Proszę podać długość.',
                    widthRequired: 'Proszę podać szerokość.',
                    heightRequired: 'Proszę podać wysokość.',
                    packageWeightRequired: 'Proszę podać wagę.',
                    maxWeightCapacityRequired: 'Proszę podać maksymalną nośność.',
                    wareUnitPackageQuantityRequired: 'Proszę podać całkowitą dodatnią liczbę opakowań.'
                }
            }
        },
        confirmations: {
            leavePage: {
                title: 'Niezapisane zmiany',
                content: 'Czy na pewno opuścić widok bez zapisywania zmian?'
            },
            deleteAddress: {
                title: 'Usunięcie adresu',
                content: 'Czy na pewno usunąć wybrany adres?'
            },
            copyAddress: {
                title: 'Kopiowanie adresu',
                content: 'Czy skopiować wybrany adres na pozostałe pozycje?'
            },
            deletePackage: {
                title: 'Usunięcie pakowania',
                content: 'Czy na pewno usunąć wybrane pakowanie?'
            },
            deleteWare: {
                title: 'Usunięcie towaru',
                content: 'Czy na pewno usunąć wybrany towar?'
            }
        },
        alerts: {
            noAddresses: 'Brak adresów.',
            noPackages: 'Brak pakowania.'
        },
        validation: {
            orderNetPriceRequired: 'Proszę podać cenę netto większą niż 0.',
            productionCostRequired: 'Proszę podać koszt materiałów.',
            invalidPriceFormat: 'Niepoprawny format.'
        },
        values: {
            noAddress: 'Brak adresu'
        }
    },

    tooltips: {
        inProduction: 'W produkcji',
        pendingMigration: 'Akcja będzie dostępna po migracji kolejnych etapów.',
        importAddressesDisabled: 'Import adresów jest dostępny tylko dla nowych zleceń spedycyjnych.',
        editAddressDisabled: 'Edycja adresu nie jest dostępna dla tego statusu zlecenia.'
    },

    errors: {
        fetchList: 'Pobranie listy zleceń spedycyjnych nie powiodło się.',
        fetchDetails: 'Pobranie danych zlecenia spedycyjnego nie powiodło się.',
        fetchStatuses: 'Pobranie statusów zleceń spedycyjnych nie powiodło się.',
        fetchHistory: 'Pobranie historii zmian zlecenia spedycyjnego nie powiodło się.',
        fetchCampaignProducts: 'Pobranie produktów kampanii nie powiodło się.',
        fetchDeliveryMethods: 'Pobranie środków transportu nie powiodło się.',
        create: 'Utworzenie zlecenia spedycyjnego nie powiodło się.',
        update: 'Aktualizacja zlecenia spedycyjnego nie powiodła się.',
        updateGoodItem: 'Aktualizacja towaru zlecenia spedycyjnego nie powiodła się.',
        print: 'Wygenerowanie zlecenia spedycyjnego nie powiodło się.',
        generateReport: 'Wygenerowanie raportu zleceń spedycyjnych nie powiodło się.',
        createFromOrders: 'Utworzenie zlecenia spedycyjnego z kampanii nie powiodło się.'
    },

    notifications: {
        createSuccess: 'Zlecenie spedycyjne zostało utworzone.',
        updateSuccess: 'Zlecenie spedycyjne zostało zapisane.',
        saveWarning: 'Zlecenie spedycyjne zostało zapisane. Pozostał towar nie przypisany do adresu.',
        addressCopied: 'Adres został skopiowany.',
        reportSuccess: 'Raport po wygenerowaniu zostanie wysłany na adres {email}.'
    }
}

export default {
    messages,
    locale: 'pl'
}
